// eslint-disable-next-line
import fsLightbox from 'fslightbox';

const heroVideo = document.querySelector('#hero-video-background');
const heroVideoBtn = document.querySelector('#hero-video-bg-toggle');
const heroVideoText = document.querySelector('#hero-video-bg-toggle-text');
const heroPopUpBtn = document.querySelector('#hero-popup-btn');

const playHeroVideo = () => {

    heroVideo.play();
    heroVideoText.innerText = 'Pause';

};

const pauseHeroVideo = () => {

    heroVideo.pause();
    heroVideoText.innerText = 'Play';

};

heroVideo.addEventListener('playing', () => {

    if (heroVideo.readyState === 4) {

        heroVideo.classList.add('js-loaded');

        const heroVideoLoader = document.getElementById('hero-video-loader');
        heroVideoLoader.classList.add('lg:hidden');

        const heroVideoPlayToggle = document.getElementById('hero-video-bg-toggle');
        heroVideoPlayToggle.classList.remove('hidden');
        heroVideoPlayToggle.classList.add('inline-flex');

    }

});

heroVideoBtn.addEventListener('click', () => {

    // Pause Button Active
    if (heroVideoText.innerText === 'Pause') {

        pauseHeroVideo();

    } else {

        // Play Button Active
        playHeroVideo();

    }

});

if (heroPopUpBtn && heroVideo) {

    // eslint-disable-next-line
    fsLightboxInstances['hero-video-popup'].props.onOpen = () => {

        pauseHeroVideo();

    };

    // eslint-disable-next-line
    fsLightboxInstances['hero-video-popup'].props.onClose = () => {

        playHeroVideo();

    };

}
